import { object, string } from 'yup';

export const loginSchema = () => {
  return object().shape({
    email: string().emailFormat().required(),
  });
};
